import { STATIONS } from "@/content/landing";
import { formatStay, stopMinutes } from "@/lib/stay-clock";

export function stayLabel(index: number): string {
  const t = formatStay(stopMinutes(STATIONS[index]));
  return `${t.day} ${t.hh}:${t.mm}`;
}

/**
 * 첫 화면 아래의 체류 띠 — 게스트 한 명의 체류를 가로선 하나로 요약하고, 각 정거장은
 * 아래 스토리의 해당 시각으로 이동하는 링크다. 데스크톱에서는 "지금" 표식이 정거장을
 * 하나씩 건너가며 그 시각을 켠다(가만히 있어도 체류가 흘러간다). 모바일은 첫 정거장에서
 * 신호만 퍼진다.
 */
export function StayStrip() {
  return (
    <nav aria-label="게스트 한 명의 체류" className="relative" data-strip>
      <div className="sl-rule" data-draw data-intro data-delay="0.35" />
      <span aria-hidden="true" className="sl-strip__track hidden md:block">
        <span className="sl-strip__now" data-strip-now />
      </span>
      <ol className="sl-strip__scroll -mx-4 flex snap-x snap-mandatory scroll-px-4 overflow-x-auto px-4 sm:-mx-6 sm:scroll-px-6 sm:px-6 md:mx-0 md:grid md:grid-cols-6 md:overflow-visible md:px-0">
        {STATIONS.map((s, i) => (
          <li key={s.id} className="shrink-0">
            <a href={`#stay-${s.id}`} className="sl-strip__stop" data-strip-stop>
              <span aria-hidden className={i === 0 ? "sl-tick sl-tick--now" : "sl-tick"} />
              <span className="sl-time text-[13px] font-semibold">{stayLabel(i)}</span>
              <span className="self-start text-[13px] sl-muted">
                <span className="sl-draw">{s.short}</span>
              </span>
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
